import { render, staticRenderFns } from "./etapa_11.vue?vue&type=template&id=59f481ba&scoped=true&"
import script from "./etapa_11.vue?vue&type=script&lang=js&"
export * from "./etapa_11.vue?vue&type=script&lang=js&"
import style0 from "./etapa_11.vue?vue&type=style&index=0&id=59f481ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f481ba",
  null
  
)

export default component.exports